// extracted by mini-css-extract-plugin
export default {"headerPage":"styles_headerPage__3T8ob"};